import { j as s } from "../../jsx-runtime-p91LotPX.mjs";
import g from "./style.js";
function B(o) {
  const {
    text: r,
    noBg: t,
    wordBreak: e,
    style: {
      backgroundColor: a,
      textColor: n
    }
  } = o;
  return /* @__PURE__ */ s.jsx(g, { cssvars: {
    tagBg: t ? "transparent" : a,
    tagText: n
  }, break: e, noBg: t ? "no-Bg" : void 0, children: r });
}
export {
  B as StatusTag
};
//# sourceMappingURL=StatusTag.js.map
